import React, { useEffect, useState } from "react";
import HeadOrderDetails from "./SharedModule/HeadOrderDetails";
import { useNavigate, useParams } from "react-router-dom";
import SideOrderDetails from "./SharedModule/SideOrderDetails";
import NotFound from "./SharedModule/NotFound";
import axios from "axios";
import note from '../../src/assets/images/comments.png'
import { useSelector } from "react-redux";

export default function ClientComments() {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const [commentDetails, setCommentDetails] = useState([]);

  const { id } = useParams();

  const getComments = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/portal/orders/${id}/user-comments`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(response.data.data.user_comments);
      setCommentDetails(response.data.data.user_comments);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const goToOrderDetails = () => {
    navigate(`/orders/${id}`);
  };

  const goToActivityDetails = () => {
    navigate(`/Activity/${id}`);
  };

  const goToCheckBefore = () => {
    navigate(`/checkBefore/${id}`);
  };

  const goToCheckAfter = () => {
    navigate(`/checkAfter/${id}`);
  };

  useEffect(() => {
    getComments();
  }, [])

  return (
    <>
      {/* Head Details */}
      <HeadOrderDetails />
      {/* Details Filteration */}
      <div className="details-filter mx-4">
        <button onClick={goToOrderDetails} className="btn">
          Order Details
        </button>
        <button onClick={goToActivityDetails} className="btn ">
          Activity logs
        </button>
        <button className="btn bg-black text-white">Client Comments</button>
        {user.operator.roles[0].name === "outbound-agent" ? (
          ""
        ) : (
          <>
            <button className="btn" onClick={goToCheckBefore}>
              Check Body Before
            </button>
            <button className="btn" onClick={goToCheckAfter}>
              Check Body After
            </button>
          </>
        )}
      </div>
      {/* Comments Details  */}
      <div className=" Comments Details">
        <div className="row m-4 justify-content-between">
          <div className="col-sm-12 col-md-8 border border-1 rounded-2">
            <div className="px-2 py-3 border-bottom border-2">
              <h3 className="pt-2">Client Comments</h3>
            </div>
            {/* Activity Logs  */}
            {commentDetails && commentDetails.length > 0 ? (
              <div className="comments-container">
                {commentDetails.map((comment) => {
                  return (
                    <div key={comment.id} className="py-3 border-bottom ">
                      <div className="d-flex justify-content-end align-items-center">
                        <h4 className="my-0 mx-2 text-muted">
                          {comment.title} Comments
                        </h4>
                      <img
                        src={comment.icon || note}
                        alt={comment.title}
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "contain",
                        }}
                        onError={(e) => {
                          e.target.onerror = null; 
                          e.target.src = note;
                        }}
                        />
                      </div>
                      <p className=" my-0 mx-2 fs-5 fw-semibold ">
                        {comment.comments[0].content}
                      </p>
                    </div>
                  );
                })}
              </div>
            ) : (
              <NotFound
                paragraphText={
                  "No Comments yet. All your Comments will appear here once you get started."
                }
              />
            )}
          </div>
          {/* SideOrderDetails  */}
          <SideOrderDetails />
        </div>
      </div>
    </>
  );
}
